import * as Dtos from "../dtos/Tmd.dtos";
import {  IFormFilter } from "../reducers/index";

export const
    LoadTrialGroupItemTemplateCategory: ITrialGroupItemTemplateCategoryLoadActionCreator = () => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD
        }
    },
    LoadTrialGroupItemTemplateCategoryById: ITrialGroupItemTemplateCategoryLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialGroupItemTemplateCategoryLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialGroupItemTemplateCategoryLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialGroupItemTemplateCategory: ITrialGroupItemTemplateCategorySaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialGroupItemTemplateCategorySaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialGroupItemTemplateCategorySaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrialGroupItemTemplateCategory: ITrialGroupItemTemplateCategoryCreateActionCreator = () => {

        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE
        }
    },
    CreateSuccess: ITrialGroupItemTemplateCategoryCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialGroupItemTemplateCategoryCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialGroupItemTemplateCategory: ITrialGroupItemTemplateCategoryValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialGroupItemTemplateCategoryValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialGroupItemTemplateCategoryValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialGroupItemTemplateCategoryClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CLEAR,
            propertiesToClear
        }
    },
    Filter: ITrialGroupItemTemplateCategoryFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD",
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_BY_ID = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_BY_ID",
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_SUCCESS = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_SUCCESS",
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_FAILURE = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_FAILURE",

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE",
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_SUCCESS = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_SUCCESS",
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_FAILURE = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_FAILURE",

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE",
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_SUCCESS = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_SUCCESS",
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_FAILURE = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_FAILURE",

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE",
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS",
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_FAILURE = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_FAILURE",

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CLEAR = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CLEAR",

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_FILTER = "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_FILTER";

export interface ITrialGroupItemTemplateCategoryLoadAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD";
}

export interface ITrialGroupItemTemplateCategoryLoadActionCreator {
    (): ITrialGroupItemTemplateCategoryLoadAction;
}

export interface ITrialGroupItemTemplateCategoryLoadSuccessAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_SUCCESS";
    formData: Dtos.TrialGroupItemTemplateCategory | Dtos.TrialGroupItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupItemTemplateCategoryLoadSuccessActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplateCategory | Dtos.TrialGroupItemTemplateCategory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupItemTemplateCategoryLoadSuccessAction;
}

export interface ITrialGroupItemTemplateCategoryLoadFailureAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupItemTemplateCategoryLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateCategoryLoadFailureAction;
}

export interface ITrialGroupItemTemplateCategoryLoadByIdAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_BY_ID";
    id: number;
}

export interface ITrialGroupItemTemplateCategoryLoadByIdActionCreator {
    (id: number): ITrialGroupItemTemplateCategoryLoadByIdAction;
}


export interface ITrialGroupItemTemplateCategorySaveAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE";
    formData: Dtos.TrialGroupItemTemplateCategory;

}

export interface ITrialGroupItemTemplateCategorySaveActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplateCategory
    ): ITrialGroupItemTemplateCategorySaveAction;
}

export interface ITrialGroupItemTemplateCategorySaveSuccessAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_SUCCESS";
    formData: Dtos.TrialGroupItemTemplateCategory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupItemTemplateCategorySaveSuccessActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplateCategory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupItemTemplateCategorySaveSuccessAction;
}

export interface ITrialGroupItemTemplateCategorySaveFailureAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupItemTemplateCategorySaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateCategorySaveFailureAction;
}

export interface ITrialGroupItemTemplateCategoryCreateAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE"
}

export interface ITrialGroupItemTemplateCategoryCreateActionCreator {
    (): ITrialGroupItemTemplateCategoryCreateAction
}

export interface ITrialGroupItemTemplateCategoryCreateSuccessAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_SUCCESS";
    formData: Dtos.TrialGroupItemTemplateCategory;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialGroupItemTemplateCategoryCreateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplateCategory,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialGroupItemTemplateCategoryCreateSuccessAction;
}

export interface ITrialGroupItemTemplateCategoryCreateFailureAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupItemTemplateCategoryCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateCategoryCreateFailureAction;
}

export interface ITrialGroupItemTemplateCategoryValidateAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE";
    formData: Dtos.TrialGroupItemTemplateCategory;

}

export interface ITrialGroupItemTemplateCategoryValidateActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplateCategory
    ): ITrialGroupItemTemplateCategoryValidateAction;
}

export interface ITrialGroupItemTemplateCategoryValidateSuccessAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS";
    formData: Dtos.TrialGroupItemTemplateCategory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupItemTemplateCategoryValidateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupItemTemplateCategory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupItemTemplateCategoryValidateSuccessAction;
}

export interface ITrialGroupItemTemplateCategoryValidateFailureAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupItemTemplateCategoryValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateCategoryValidateFailureAction;
}

export interface ITrialGroupItemTemplateCategoryClearAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialGroupItemTemplateCategoryClearActionCreator {
    (propertiesToClear?: string[]): ITrialGroupItemTemplateCategoryClearAction;
}

export interface ITrialGroupItemTemplateCategoryFilterActionCreator {
    (formFilter: IFormFilter): ITrialGroupItemTemplateCategoryFilterAction;
}

export interface ITrialGroupItemTemplateCategoryFilterAction {
    type: "ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_FILTER";
    formFilter: IFormFilter;
}

export type TrialGroupItemTemplateCategoryAction =
    ITrialGroupItemTemplateCategoryLoadAction |
    ITrialGroupItemTemplateCategoryLoadByIdAction |
    ITrialGroupItemTemplateCategoryLoadFailureAction |
    ITrialGroupItemTemplateCategoryLoadSuccessAction |
    ITrialGroupItemTemplateCategorySaveAction |
    ITrialGroupItemTemplateCategorySaveSuccessAction |
    ITrialGroupItemTemplateCategorySaveFailureAction |
    ITrialGroupItemTemplateCategoryCreateAction |
    ITrialGroupItemTemplateCategoryCreateSuccessAction |
    ITrialGroupItemTemplateCategoryCreateFailureAction |
    ITrialGroupItemTemplateCategoryValidateAction |
    ITrialGroupItemTemplateCategoryValidateSuccessAction |
    ITrialGroupItemTemplateCategoryValidateFailureAction |
    ITrialGroupItemTemplateCategoryClearAction |
    ITrialGroupItemTemplateCategoryFilterAction;
